export default __webpack_public_path__ + "images/intellectual-property.435747e2.png";